"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleManageApi = void 0;
const runtime = __importStar(require("../runtime"));
const index_1 = require("../models/index");
/**
 *
 */
class StyleManageApi extends runtime.BaseAPI {
    /**
     * 網站目錄設定-刪除選單
     */
    styleManageDeleteDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/StyleManage/Delete`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.WebSiteMenuEditViewModelToJSON)(requestParameters['webSiteMenuEditViewModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站目錄設定-刪除選單
     */
    styleManageDeleteDelete() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.styleManageDeleteDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站目錄設定-商品列表編輯查詢
     */
    styleManageGet04GetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['menuStyleNo'] != null) {
                queryParameters['menuStyleNo'] = requestParameters['menuStyleNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/StyleManage/Get04`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站目錄設定-商品列表編輯查詢
     */
    styleManageGet04Get() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.styleManageGet04GetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站目錄設定-商品輪播編輯查詢
     */
    styleManageGet05GetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['menuStyleNo'] != null) {
                queryParameters['menuStyleNo'] = requestParameters['menuStyleNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/StyleManage/Get05`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站目錄設定-商品輪播編輯查詢
     */
    styleManageGet05Get() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.styleManageGet05GetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    styleManageGetBaseInformationGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/StyleManage/GetBaseInformation`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     */
    styleManageGetBaseInformationGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.styleManageGetBaseInformationGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站目錄設定-樣式二編輯查詢
     */
    styleManageGetGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['menuStyleNo'] != null) {
                queryParameters['menuStyleNo'] = requestParameters['menuStyleNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/StyleManage/Get`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站目錄設定-樣式二編輯查詢
     */
    styleManageGetGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.styleManageGetGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站目錄設定-選單編輯頁查詢
     */
    styleManageGetMenuByIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['no'] != null) {
                queryParameters['no'] = requestParameters['no'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/StyleManage/GetMenuById`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站目錄設定-選單編輯頁查詢
     */
    styleManageGetMenuByIdGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.styleManageGetMenuByIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站目錄設定-選單獲取
     */
    styleManageGetMenuGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['no'] != null) {
                queryParameters['no'] = requestParameters['no'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/StyleManage/GetMenu`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站目錄設定-選單獲取
     */
    styleManageGetMenuGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.styleManageGetMenuGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站目錄設定-取得預覽畫面
     */
    styleManageGetMenuStylePageGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['menuNo'] != null) {
                queryParameters['menuNo'] = requestParameters['menuNo'];
            }
            if (requestParameters['menuStyleNo'] != null) {
                queryParameters['menuStyleNo'] = requestParameters['menuStyleNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/StyleManage/GetMenuStylePage`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站目錄設定-取得預覽畫面
     */
    styleManageGetMenuStylePageGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.styleManageGetMenuStylePageGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 取得商品分類下拉選單（供商品列表/商品輪播使用）
     */
    styleManageGetProductMenuListGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/StyleManage/GetProductMenuList`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 取得商品分類下拉選單（供商品列表/商品輪播使用）
     */
    styleManageGetProductMenuListGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.styleManageGetProductMenuListGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站目錄設定-獲取可設定網站名稱
     */
    styleManageGetWebSiteGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/StyleManage/GetWebSite`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站目錄設定-獲取可設定網站名稱
     */
    styleManageGetWebSiteGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.styleManageGetWebSiteGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站目錄設定-修改選單
     */
    styleManagePatchPatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/StyleManage/Patch`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.WebSiteMenuEditViewModelToJSON)(requestParameters['webSiteMenuEditViewModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站目錄設定-修改選單
     */
    styleManagePatchPatch() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.styleManagePatchPatchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站目錄設定-新增選單(下一層)
     */
    styleManagePostNextPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/StyleManage/PostNext`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.WebSiteMenuEditViewModelToJSON)(requestParameters['webSiteMenuEditViewModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站目錄設定-新增選單(下一層)
     */
    styleManagePostNextPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.styleManagePostNextPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站目錄設定-新增選單(同層)
     */
    styleManagePostSamePostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/StyleManage/PostSame`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.WebSiteMenuEditViewModelToJSON)(requestParameters['webSiteMenuEditViewModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站目錄設定-新增選單(同層)
     */
    styleManagePostSamePost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.styleManagePostSamePostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站目錄設定-預覽畫面發布
     */
    styleManagePreviewUpdatePatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['menuStyleNO'] != null) {
                formParams.append('MenuStyleNO', requestParameters['menuStyleNO']);
            }
            const response = yield this.request({
                path: `/StyleManage/PreviewUpdate`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站目錄設定-預覽畫面發布
     */
    styleManagePreviewUpdatePatch() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.styleManagePreviewUpdatePatchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站目錄設定-樣式二編輯
     */
    styleManageStyle2PatchPatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['json'] != null) {
                formParams.append('json', requestParameters['json']);
            }
            if (requestParameters['backgroundPic'] != null) {
                formParams.append('backgroundPic', requestParameters['backgroundPic']);
            }
            if (requestParameters['displayPic'] != null) {
                requestParameters['displayPic'].forEach((element) => {
                    formParams.append('displayPic', element);
                });
            }
            if (requestParameters['detailPic'] != null) {
                requestParameters['detailPic'].forEach((element) => {
                    formParams.append('detailPic', element);
                });
            }
            const response = yield this.request({
                path: `/StyleManage/Style2Patch`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站目錄設定-樣式二編輯
     */
    styleManageStyle2PatchPatch() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.styleManageStyle2PatchPatchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站目錄設定-樣式二新增
     */
    styleManageStyle2PostPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['json'] != null) {
                formParams.append('json', requestParameters['json']);
            }
            if (requestParameters['backgroundPic'] != null) {
                formParams.append('backgroundPic', requestParameters['backgroundPic']);
            }
            if (requestParameters['displayPic'] != null) {
                requestParameters['displayPic'].forEach((element) => {
                    formParams.append('displayPic', element);
                });
            }
            if (requestParameters['detailPic'] != null) {
                requestParameters['detailPic'].forEach((element) => {
                    formParams.append('detailPic', element);
                });
            }
            const response = yield this.request({
                path: `/StyleManage/Style2Post`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站目錄設定-樣式二新增
     */
    styleManageStyle2PostPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.styleManageStyle2PostPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站目錄設定-商品列表編輯
     */
    styleManageStyle4PatchPatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['json'] != null) {
                formParams.append('json', requestParameters['json']);
            }
            if (requestParameters['backgroundPic'] != null) {
                formParams.append('backgroundPic', requestParameters['backgroundPic']);
            }
            const response = yield this.request({
                path: `/StyleManage/Style4Patch`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站目錄設定-商品列表編輯
     */
    styleManageStyle4PatchPatch() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.styleManageStyle4PatchPatchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站目錄設定-商品列表新增
     */
    styleManageStyle4PostPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['json'] != null) {
                formParams.append('json', requestParameters['json']);
            }
            if (requestParameters['backgroundPic'] != null) {
                formParams.append('backgroundPic', requestParameters['backgroundPic']);
            }
            const response = yield this.request({
                path: `/StyleManage/Style4Post`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站目錄設定-商品列表新增
     */
    styleManageStyle4PostPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.styleManageStyle4PostPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站目錄設定-商品輪播編輯
     */
    styleManageStyle5PatchPatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['json'] != null) {
                formParams.append('json', requestParameters['json']);
            }
            if (requestParameters['backgroundPic'] != null) {
                formParams.append('backgroundPic', requestParameters['backgroundPic']);
            }
            const response = yield this.request({
                path: `/StyleManage/Style5Patch`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站目錄設定-商品輪播編輯
     */
    styleManageStyle5PatchPatch() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.styleManageStyle5PatchPatchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網站目錄設定-商品輪播新增
     */
    styleManageStyle5PostPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['json'] != null) {
                formParams.append('json', requestParameters['json']);
            }
            if (requestParameters['backgroundPic'] != null) {
                formParams.append('backgroundPic', requestParameters['backgroundPic']);
            }
            const response = yield this.request({
                path: `/StyleManage/Style5Post`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網站目錄設定-商品輪播新增
     */
    styleManageStyle5PostPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.styleManageStyle5PostPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.StyleManageApi = StyleManageApi;
